import { FC } from 'react';
import { MediaQueries } from '@frontend/api-media';
import { Citation } from '@frontend/task-center-scope';
import { Text, SkeletonLoader } from '@frontend/design-system';
import { MediaPreviewItem } from './media-preview-item';
import {
  mediaContainerStyle,
  previewContainerStyle,
  extraCountOverlayStyle,
  MEDIA_MAX_HEIGHT,
} from './media-preview.styles';

interface MediaPreviewGroupProps {
  citationMediaIds: NonNullable<Citation['media_ids']>;
  locationId: string;
  maxVisible?: number;
  messageOutbound?: boolean;
}

export const MediaPreviewGroup: FC<MediaPreviewGroupProps> = ({
  citationMediaIds,
  locationId,
  messageOutbound,
  maxVisible = 2,
}) => {
  const visibleItems = citationMediaIds.slice(0, maxVisible);
  const media = MediaQueries.useMmsMedia({
    mediaItems: visibleItems,
    locationId,
  });
  const visibleMediaSources = media.flatMap((item) => (item.data ? [item.data] : []));
  const isLoading = media.some((item) => item.isLoading);

  // The count will incremented by 1. because we are showing one extra item as overlay when media exceeds the
  // maxVisible count.
  const extraCount = citationMediaIds.length - maxVisible + 1;

  const showExtraCount = citationMediaIds.length > maxVisible && !isLoading;

  return (
    <span css={mediaContainerStyle(Boolean(messageOutbound))}>
      {isLoading ? (
        <>
          <SkeletonLoader width='50%' height={MEDIA_MAX_HEIGHT} />
          <SkeletonLoader width='50%' height={MEDIA_MAX_HEIGHT} />
        </>
      ) : (
        visibleMediaSources.map((item, index) => (
          <div key={item.mediaId} css={previewContainerStyle}>
            <MediaPreviewItem {...item} />
            {showExtraCount && maxVisible === index + 1 && (
              <span css={extraCountOverlayStyle}>
                <Text color='white'>+{extraCount}</Text>
              </span>
            )}
          </div>
        ))
      )}
    </span>
  );
};
